import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
// import moment from 'moment';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { stat } from 'fs';
import { SHIFT_WORKERS_DATA } from '../_store';

interface ShiftFormState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;
    form: any;
    schema: any;

    asyncValidationLoading: boolean;
    hasAsyncError: boolean;
    asyncErrors: any[];
    workers: any[];
    targetForDelete: any[];

    meta: any;
    meta_worker: any;
}

const state: ShiftFormState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,
    form: null,
    schema: null,

    asyncValidationLoading: false,
    hasAsyncError: false,
    asyncErrors: [],
    workers: [],
    targetForDelete: [],

    meta: {},
    meta_worker: {},
};

const initState: any = cloneDeep(state);

export const SHIFT_DATA = 'GET_SHIFT_DATA';
export const SHIFT_WORKER_DATA = 'GET_SHIFT_WORKER_DATA';
export const SHIFT_SCHEMA = 'GET_SHIFT_SCHEMA';
export const SELECT_ROLES_OP = 'SELECT_ROLES_OP';
export const SELECT_GRANTS_OP = 'SELECT_GRANTS_OP';

export const actions: ActionTree<ShiftFormState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    loadData({ commit, getters, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(SHIFT_DATA)
                    .raw('documents.get')
                    .action({
                        id: params.id
                    }),
                vm.$q(SHIFT_WORKER_DATA)
                    .raw('documents.list')
                    .action({
                        columns: {
                            id: 'sw.id',
                            employee_id: 'sw.employee_id',
                            role_id: 'sw.role_id',
                            is_combined: 'sw.is_combined',
                            combine_time: 'sw.combine_time',
                        },

                        from: 's:shift_workers',
                        from_as: 'sw',
                        where: {
                          $eq: [`sw.shift_id`, {$: params.id}]
                        },
                        order: [
                            {$asc: ['sw.id']}
                        ]
                    }),
            ]).then((result: ServerResult) => {
                commit('SET_FORM_DATA', {
                    document: result.getOperation(SHIFT_DATA).getContent(),
                    workers: result.getOperation(SHIFT_WORKER_DATA).getContent(),
                });

                commit('LOADED_SUCCESS');
                resolve(null);
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    addWorker({state, commit}) {
        if (!state.form.workers) {
            state.form.workers = []
        }
        commit('ADD_WORKER');
    },

    removeWorker({commit}, idx) {
        commit('REMOVE_WORKER', idx);
    },

    prepareNew({ commit, rootState }, initParams) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(SHIFT_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:shifts`
                    })
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    schema: result.getOperation(SHIFT_SCHEMA).getContent(),
                    initParams,
                    defs: {
                        manager_id: (rootState as any).ubic.actor.document.id
                    }
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    changeFormValue({state, commit}, {field, newValue}) {
        commit('CHANGE_VALUE', {field, newValue});
    },

    changeWorkerValue({state, commit}, {field, newValue, idx}) {
        commit('CHANGE_WORKER_VALUE', {field, newValue, idx});
    },

    saveForm({ commit, getters, dispatch }, params) {
        const vm = (this as any)._vm;

        const normalizedForm = state.schema.fields.reduce((prev: any, field: any) => {
            const fieldName = field.code;

            console.log(fieldName, state.form[fieldName], field)

            if (state.form[fieldName]) {
                switch(field.type) {
                    case 'date': {
                        prev[fieldName] = moment(state.form[fieldName]).utc().local().format('YYYY-MM-DD');
                        break;
                    }
                    case 'time': {
                        prev[fieldName] = moment(state.form[fieldName]).utc().local().format('HH:mm:ss');
                        break;
                    }
                    default: {
                        prev[fieldName] = state.form[fieldName]
                    }
                }

            }

            return prev
        }, {});


        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            let saveQuery = null;
            if (params.id) {
                saveQuery = vm.$q('SHIFT_DATA_SAVE')
                    .update(params.id, normalizedForm)
            } else {
                saveQuery = vm.$q('SHIFT_DATA_SAVE')
                    .create('s:shifts', normalizedForm)
            }
            console.log('3')
            console.log('saveQuery', saveQuery)

            vm.$db([
                saveQuery
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SHIFT_DATA_SAVE');
                console.log('4')
                if (operationResult.hasError()) {
                    console.log('error', operationResult.getContent());

                    commit('LOADED_SUCCESS');
                    reject();
                } else {
                    commit('ON_FORM_SAVE', { document: operationResult.getContent(), savedGrants: state.form.roles})

                    state.workers = state.workers.map((item: any) => {
                        item.shift_id = state.form.id
                        if (item.is_combined && item.combine_time) {
                            item.combine_time = moment(item.combine_time).utc().local().format('HH:mm:ss');
                        }
                        return item
                    })

                    const queries = [
                        vm.$q(`SAVE_DEAL_BASKET`)
                          .update(state.form.id, {})
                          .createManyRelation('shift_workers', 'shift_id', (createRelated: any) => {
                            return state.workers.filter((item: any) => !item.id).map((item, index) => createRelated(item));
                          })
                          .updateManyRelation('shift_workers', 'shift_id', (updateRelated: any) => {
                            return state.workers.filter((item: any) => item.id).map((item, index) => updateRelated(item))
                          })
                          .deleteManyRelation('shift_workers', 'shift_id', (deleteRelated: any) => {
                            return state.targetForDelete.map((item: any, index) => deleteRelated({ id: item }));
                          })
                    ]

                    vm.$db(queries).then((result: ServerResult) => {
                        commit('LOADED_SUCCESS');
                        resolve(operationResult.getContent());
                    })

                }
            })
            .catch((error: any) => {
                console.log('errror', error)
            });
        })
    },
};

export const mutations: MutationTree<ShiftFormState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = initState[key]
        }
    },
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },
    START_ASYNC_VALIDATION: (state) => {
        state.asyncValidationLoading = true;
    },
    SET_ASYNC_ERROR: (state, errors: any[]) => {
        state.asyncValidationLoading = false;
        state.hasAsyncError = errors.length > 0
        state.asyncErrors = errors;
    },

    SET_FORM_DATA(state, {document, workers}) {
        state.document = document.document;
        state.schema = document.schema;
        state.meta = fetchEnumsFromSchema(document.schema);

        const formData = cloneDeep(state.document);

        for(const field of state.schema.fields) {
            if(['date', 'datetime'].includes(field.type)) {
                formData[field.code] = formData[field.code] ? moment(formData[field.code]).toDate() : null;
            }
            if(['begin_time', 'end_time'].includes(field.code)) {
                formData[field.code] = formData[field.code] ? moment(formData[field.code], 'HH:mm:ss.0000000').toDate() : null;
            }
        }

        state.form = formData;
        state.workers = workers.documents.map((item: any) => {
            if (item.is_combined && item.combine_time) {
                item.combine_time = moment(item.combine_time, 'HH:mm:ss.0000000').toDate();
            }
            return item
        })
    },

    GENERATE_FORM_DATA(state, {schema, initParams, defs}) {
        state.document = {};
        state.schema = schema.schema;
        state.meta = fetchEnumsFromSchema(schema.schema);

        const formData = state.schema.fields.reduce((prev: any, field: any) => {
            if (initParams[field.code]) {
                if(['date', 'datetime'].includes(field.type)) {
                    prev[field.code] = moment(initParams[field.code]).toDate();
                } else {
                    prev[field.code] = initParams[field.code];
                }
            } else if (defs[field.code]) {
                if(['date', 'datetime'].includes(field.type)) {
                    prev[field.code] = moment(defs[field.code]).toDate();
                } else {
                    prev[field.code] = defs[field.code];
                }
            }
            else {
                prev[field.code] = null;
            }

            return prev;
        }, {})
        formData.workers = [];

        state.form = formData;
    },

    ON_FORM_SAVE(state, {document, savedGrants}) {
        state.document = document.document;
        state.schema = document.schema;

        const formData = cloneDeep(state.document);
        for(const field of state.schema.fields) {
            if(['date', 'datetime'].includes(field.type)) {
                formData[field.code] = formData[field.code] ? moment(formData[field.code]).toDate() : null;
            }
        }

        state.form = formData;
    },

    CHANGE_VALUE(state: ShiftFormState, {field, newValue}) {
        console.log('!! --> ', field, newValue);
        switch (field) {
            case 'begin_time':
            case 'end_time':
                state.form[field] = newValue + ':00';
                break

            default:
                state.form[field] = newValue;
        }
    },

    ADD_WORKER(state: ShiftFormState) {
        state.workers.push({shift_id: state.form.id})
    },

    REMOVE_WORKER(state: ShiftFormState, idx: number) {
        if (state.workers[idx].id) {
            state.targetForDelete.push(state.workers[idx].id)
        }
        state.workers.splice(idx, 1)
    },

    CHANGE_WORKER_VALUE(state: ShiftFormState, {field, newValue, idx}) {
        console.log(field, newValue, idx)
        switch (field) {
            default:
                state.workers[idx][field] = newValue;
        }
    },
};

const getters = {
    fields: (state: ShiftFormState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_deal_details_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
